// extracted by mini-css-extract-plugin
module.exports = {"layoutDarkContent":"style_layoutDarkContent__bE2QQ","layoutDefaultBox":"style_layoutDefaultBox__1VHnC"};